export default class Animations
{
    constructor() {
        document.addEventListener('animationend', (e) => {
            const animationName = e.animationName;
            if (animationName === 'fill-up-progress-bar') {
                this.progressBarInitialAnimation(e);
            }
        });
    }

    progressBarInitialAnimation(e)
    {
        e.target.classList.remove('progress-bar-fill--initial-animation');
    }
}